const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;




  // const validateExcelHeaders = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const isExcel =
  //       file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
  //       file.name.endsWith('.xlsx');
  
  //     if (!isExcel) {
  //       reject('Invalid file type. Please upload an Excel file.');
  //       return;
  //     }
  
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       try {
  //         const data = new Uint8Array(e.target.result);
  //         const workbook = XLSX.read(data, { type: 'array' });
  
  //         let isValid = true; // Flag to track overall file validity
  //         let invalidSheets = []; // To track invalid sheets
  //         let invalidHeadersDetails = []; // Store invalid header details
  //         let extractedData = [];
  
  //         workbook.SheetNames.forEach((sheetName) => {
  //           const worksheet = workbook.Sheets[sheetName];
  //           const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  
  //           let isSheetValid = false; // Flag to track sheet validity
  
  //           // Iterate through all rows to find headers in any table
  //           for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
  //             const row = rows[rowIndex];
  //             const headers = row; // Treat the current row as headers
  
  //             // Check if the row contains valid headers
  //             const hasValidHeaders = Object.keys(expectedHeaders).every(
  //               (category) =>
  //                 expectedHeaders[category].some((validHeader) =>
  //                   headers.some(
  //                     (header) =>
  //                       typeof header === 'string' && // Ensure header is a string
  //                       header.trim().toLowerCase() === validHeader.toLowerCase() // Exact match
  //                   ),
  //                 ),
  //             );
  
  //             if (hasValidHeaders) {
  //               isSheetValid = true;
  
  //               // Extract data for the valid table
  //               const sheetData = extractColumnData(
  //                 worksheet,
  //                 headers,
  //                 expectedHeaders,
  //               );
  //               extractedData.push(
  //                 ...sheetData.map((item) => ({
  //                   ...item,
  //                   fileUid: file.uid,
  //                   fileName: file.name,
  //                 })),
  //               );
  
  //               // Stop searching further in this sheet since we found valid headers
  //               break;
  //             }
  //           }
  
  //           // If no valid headers found in the entire sheet, mark the sheet as invalid
  //           if (!isSheetValid) {
  //             invalidSheets.push(sheetName);
  //             invalidHeadersDetails.push({
  //               fileName: file.name,
  //               sheetName,
  //               invalidHeader: 'Invalid headers',
  //             });
  //             isValid = false;
  //           }
  //         });
  
  //         if (isValid) {
  //           console.log('Extracted Data from Excel:', extractedData);
  
  //           // Merge with previously extracted data and link each data item with fileUid
  //           setAllExtractedData((prevData) => {
  //             return [...prevData, ...extractedData];
  //           });
  
  //           resolve(); // Return after data has been merged
  //         } else {
  //           // Here, instead of rejecting the file, display a message in the popup
  //           const errorMessage = invalidHeadersDetails
  //             .map(
  //               (detail) =>
  //                 `Invalid headers in sheet "${detail.sheetName}" from file "${detail.fileName}"`
  //             )
  //             .join('\n');
            
  //           // Trigger the popup with the error message (this part depends on your existing code for popups)
  //           //showErrorPopup(errorMessage); // Assuming showErrorPopup is your function to show the popup
  
  //           reject(errorMessage); // Rejecting for the sake of the Promise API, but not stopping processing
  //         }
  //       } catch (error) {
  //         reject('Error reading the file.');
  //       }
  //     };
  
  //     reader.readAsArrayBuffer(file);
  //   });
  // };













  // 2nd

  // const validateExcelHeaders = (file) => {
  //     return new Promise((resolve, reject) => {
  //       const isExcel =
  //         file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
  //         file.name.endsWith('.xlsx');
    
  //       if (!isExcel) {
  //         reject('Invalid file type. Please upload an Excel file.');
  //         return;
  //       }
    
  //       const reader = new FileReader();
  //       reader.onload = (e) => {
  //         try {
  //           const data = new Uint8Array(e.target.result);
  //           const workbook = XLSX.read(data, { type: 'array' });
    
  //           let isValid = true; // Flag to track overall file validity
  //           let invalidSheets = []; // To track invalid sheets
  //           let invalidHeadersDetails = []; // Store invalid header details
  //           let extractedData = [];
    
  //           workbook.SheetNames.forEach((sheetName) => {
  //             const worksheet = workbook.Sheets[sheetName];
  //             const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    
  //             let isSheetValid = false; // Flag to track sheet validity
  //             let invalidHeadersForSheet = []; // Store invalid headers for the current sheet
    
  //             // Iterate through all rows to find headers in any table
  //             for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
  //               const row = rows[rowIndex];
  //               const headers = row; // Treat the current row as headers
    
  //               // Check if the row contains valid headers
  //               const hasValidHeaders = Object.keys(expectedHeaders).every(
  //                 (category) =>
  //                   expectedHeaders[category].some((validHeader) =>
  //                     headers.some(
  //                       (header) =>
  //                         typeof header === 'string' && // Ensure header is a string
  //                         header.trim().toLowerCase() === validHeader.toLowerCase() // Exact match
  //                     )
  //                   )
  //               );
    
  //               if (hasValidHeaders) {
  //                 isSheetValid = true;
    
  //                 // Extract data for the valid table
  //                 const sheetData = extractColumnData(worksheet, headers, expectedHeaders);
  //                 extractedData.push(
  //                   ...sheetData.map((item) => ({
  //                     ...item,
  //                     fileUid: file.uid,
  //                     fileName: file.name,
  //                   }))
  //                 );
    
  //                 // Stop searching further in this sheet since we found valid headers
  //                 break;
  //               } else {
  //                 // Add the invalid headers to the list
  //                 headers.forEach((header) => {
  //                   if (
  //                     typeof header === 'string' && // Ensure header is a string
  //                     !Object.keys(expectedHeaders).some(
  //                       (category) =>
  //                         expectedHeaders[category].some((validHeader) =>
  //                           header.trim().toLowerCase() === validHeader.toLowerCase()
  //                         )
  //                     )
  //                   ) {
  //                     // Find the category that this invalid header belongs to, but only if no valid header was found
  //                     Object.keys(expectedHeaders).forEach((category) => {
  //                       // Only associate with category if no valid header was found for this category
  //                       const isValidCategory = expectedHeaders[category].some((validHeader) =>
  //                         headers.some(
  //                           (header) =>
  //                             header.trim().toLowerCase() === validHeader.toLowerCase()
  //                         )
  //                       );
                
  //                       if (!isValidCategory) {
  //                         // Only log invalid headers if the category is not already validated
  //                         invalidHeadersForSheet.push({
  //                           header,
  //                           category,
  //                         });
  //                       }
  //                     });
  //                   }
  //                 });
  //               }
  //             }
    
  //             // If no valid headers found in the entire sheet, mark the sheet as invalid
  //             if (!isSheetValid) {
  //               invalidSheets.push(sheetName);
  //               invalidHeadersDetails.push({
  //                 fileName: file.name,
  //                 sheetName,
  //                 invalidHeaders: invalidHeadersForSheet,
  //               });
  //               isValid = false;
  //             }
  //           });
    
  //           if (isValid) {
  //             console.log('Extracted Data from Excel:', extractedData);
    
  //             // Merge with previously extracted data and link each data item with fileUid
  //             setAllExtractedData((prevData) => {
  //               return [...prevData, ...extractedData];
  //             });
    
  //             resolve(); // Return after data has been merged
  //           } else {
  //             // Display error message with invalid headers for each sheet
  //             const errorMessage = invalidHeadersDetails
  //             .map((detail) => {
  //               const invalidHeaders = detail.invalidHeaders
  //                 .map(
  //                   (item) =>
  //                     `Invalid header "${item.header}" found under "${item.category}" category.`
  //                 ) // Format error for invalid headers with category
  //                 .join('\n');
  
  //               return `Invalid headers in sheet "${detail.sheetName}" from file "${detail.fileName}":\n ${invalidHeaders}`;
  //             })
  //             .join('\n');
  //             // Trigger the popup with the error message (this part depends on your existing code for popups)
  //             // showErrorPopup(errorMessage); // Assuming showErrorPopup is your function to show the popup
    
  //             reject(errorMessage); // Rejecting for the sake of the Promise API, but not stopping processing
  //           }
  //         } catch (error) {
  //           reject('Error reading the file.');
  //         }
  //       };
    
  //       reader.readAsArrayBuffer(file);
  //     });
  //   };
    
  



  //3rd

  // const validateExcelHeaders = (file) => {
  //     return new Promise((resolve, reject) => {
  //       const isExcel =
  //         file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
  //         file.name.endsWith('.xlsx');
    
  //       if (!isExcel) {
  //         reject('Invalid file type. Please upload an Excel file.');
  //         return;
  //       }
    
  //       const reader = new FileReader();
  //       reader.onload = (e) => {
  //         try {
  //           const data = new Uint8Array(e.target.result);
  //           const workbook = XLSX.read(data, { type: 'array' });
    
  //           let isValid = true; // Flag to track overall file validity
  //           let invalidSheets = []; // To track invalid sheets
  //           let invalidHeadersDetails = []; // Store invalid header details
  //           let extractedData = [];
    
  //           workbook.SheetNames.forEach((sheetName) => {
  //             const worksheet = workbook.Sheets[sheetName];
  //             const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    
  //             let isSheetValid = false; // Flag to track sheet validity
  //             let invalidHeadersForSheet = []; // Store invalid headers for the current sheet
    
  //             // Iterate through all rows to find headers in any table
  //             for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
  //               const row = rows[rowIndex];
  //               const headers = row; // Treat the current row as headers
    
  //               // Check if the row contains valid headers
  //               const hasValidHeaders = Object.keys(expectedHeaders).every(
  //                 (category) =>
  //                   expectedHeaders[category].some((validHeader) =>
  //                     headers.some(
  //                       (header) =>
  //                         typeof header === 'string' && // Ensure header is a string
  //                         header.trim().toLowerCase() === validHeader.toLowerCase() // Exact match
  //                     )
  //                   )
  //               );
    
  //               if (hasValidHeaders) {
  //                 isSheetValid = true;
    
  //                 // Extract data for the valid table
  //                 const sheetData = extractColumnData(worksheet, headers, expectedHeaders);
  //                 extractedData.push(
  //                   ...sheetData.map((item) => ({
  //                     ...item,
  //                     fileUid: file.uid,
  //                     fileName: file.name,
  //                   }))
  //                 );
    
  //                 // Stop searching further in this sheet since we found valid headers
  //                 break;
  //               } else {
  //                 // Add the invalid headers to the list
  //                 headers.forEach((header) => {
  //                   if (
  //                     typeof header === 'string' && // Ensure header is a string
  //                     !Object.keys(expectedHeaders).some(
  //                       (category) =>
  //                         expectedHeaders[category].some((validHeader) =>
  //                           header.trim().toLowerCase() === validHeader.toLowerCase()
  //                         )
  //                     )
  //                   ) {
  //                     invalidHeadersForSheet.push(header); // Push invalid header
  //                   }
  //                 });
  //               }
  //             }
    
  //             // If no valid headers found in the entire sheet, mark the sheet as invalid
  //             if (!isSheetValid) {
  //               invalidSheets.push(sheetName);
  //               invalidHeadersDetails.push({
  //                 fileName: file.name,
  //                 sheetName,
  //                 invalidHeaders: invalidHeadersForSheet,
  //               });
  //               isValid = false;
  //             }
  //           });
    
  //           if (isValid) {
  //             console.log('Extracted Data from Excel:', extractedData);
    
  //             // Merge with previously extracted data and link each data item with fileUid
  //             setAllExtractedData((prevData) => {
  //               return [...prevData, ...extractedData];
  //             });
    
  //             resolve(); // Return after data has been merged
  //           } else {
  //             // Display error message with invalid headers for each sheet
  //             const errorMessage = invalidHeadersDetails
  //               .map((detail) => {
  //                 const invalidHeaders = detail.invalidHeaders
  //                   .map((header) => typeof header === 'string' ? header : String(header)) // Ensure header is a string
  //                   .join(', ');
    
  //                 return `Invalid headers in sheet "${detail.sheetName}" from file "${detail.fileName}":\n ${invalidHeaders}`;
  //               })
  //               .join('\n');
    
  //             // Trigger the popup with the error message (this part depends on your existing code for popups)
  //             // showErrorPopup(errorMessage); // Assuming showErrorPopup is your function to show the popup
    
  //             reject(errorMessage); // Rejecting for the sake of the Promise API, but not stopping processing
  //           }
  //         } catch (error) {
  //           reject('Error reading the file.');
  //         }
  //       };
    
  //       reader.readAsArrayBuffer(file);
  //     });
  //   };
    